<template>
  <a-card>
    <div class="main-panel" style="height: 800px">
      <div style="text-align: right">
        <a-button v-has="'USER_ADD'" type="link" @click="add()">
          添加
        </a-button>
      </div>
      <div class="main-content-wrap">
        <a-row>
          <a-col :span="24">
            <a-table :loading="table.loading"
                     :data-source="table.data"
                     :default-sort="table.sort"
                     :pagination="table.pagination"
                     @change="handleTableChange"
                     ref="table.dataRef">
              <!--                <a-table-column type="index" title="No." width="100" :index="table_index" align="center">-->
              <!--                </a-table-column>-->
              <a-table-column align="center" data-index="loginName" title="登录名" width="">
              </a-table-column>
              <a-table-column align="center" data-index="userName" title="用户名" width="">
              </a-table-column>
              <a-table-column align="center" data-index="email" title="邮箱" width="">
              </a-table-column>
              <a-table-column align="center" data-index="language" title="语言" width="">
              </a-table-column>
              <a-table-column align="center" data-index="createAt" title="创建时间" width="">
              </a-table-column>
              <a-table-column align="center" title="操作">
                <template slot-scope="text, record">
                  <a-button @click="addRole(record.id)" v-has="'USER_ROLE'" type="link" size="small">角色</a-button>
                  <span class="spanCss" v-has="'USER_EDIT'">|</span>
                  <a-button @click="edit(record.id)" v-has="'USER_EDIT'" type="link" size="small">编辑</a-button>
                  <span class="spanCss" v-has="'USER_RESET_PASSWORD'">|</span>
                  <a-button @click="reset(record.id)" v-has="'USER_RESET_PASSWORD'" type="link" size="small">重置密码
                  </a-button>
                  <span class="spanCss" v-has="'USER_DELETE'">|</span>
                  <a-button @click="del(record.id)" v-has="'USER_DELETE'" type="link" size="small" class="operationBtn">
                    删除
                  </a-button>
                </template>
              </a-table-column>
            </a-table>
          </a-col>
        </a-row>
      </div>
    </div>
    <!--    <a-modal v-model="form.visible" width="600px" :destroy-on-close="true">-->
    <!--      <user-edit :user-id="form.data.userId" :on-cancel-handler="onFormCancel"-->
    <!--                 :on-save-handler="onFormSave" ref="userForm"></user-edit>-->
    <!--    </a-modal>-->
    <a-modal v-model="form.visible" width="600px" :destroy-on-close="true" @cancel="onFormCancel" @ok="onFormSave">
      <user-edit :get-list="getList" :user-id="form.data.userId" ref="userForm"></user-edit>
    </a-modal>

    <!--    <a-modal v-model="form.roleVisible" width="600px">-->
    <!--      <user-role :user-id="form.data.userId" :on-cancel-handler="onFormCancel"-->
    <!--                 :on-save-handler="onFormSave"></user-role>-->
    <!--    </a-modal>-->
    <a-modal v-model="form.roleVisible" width="600px" :destroy-on-close="true" @cancel="onFormCancel" @ok="onFormSave">
      <user-role :user-id="form.data.userId" ref="userTree"></user-role>
    </a-modal>
  </a-card>
</template>

<script>
import {getUserList, delUser, resetPassword} from '../../../api/user';
import UserEdit from './UserEdit';
import UserRole from './UserRole.vue';
import {delArea} from "../../../api/area";

/**
 * 初始化用户列表数据
 */
async function getList() {
  const currentPage = this.table.pagination.current - 1;
  const result = await getUserList(currentPage, this.table.pagination.pageSize);
    if (result.code === 1200) {
      // this.table.data = result.data.users;
      this.$set(this.table, 'data', result.data.users);
      this.$set(this.table.pagination, 'total', result.data.totalCount);
      // this.table.pagination.total = result.data.totalCount;
    }
}


async function onFormSave() {
  // setTimeout(()=>{
    if (this.form.visible) {
      this.$refs.userForm.save()
    }
    if (this.form.roleVisible) {
      this.$refs.userTree.save()
    }
    this.form.visible = false;
    this.form.roleVisible = false;
    this.form.data = {};
    // this.getList();
  // },10000);
}


function onFormCancel() {
  this.form.visible = false;
  this.form.roleVisible = false;
  this.getList();
  this.form.data = {};
}

function edit(id) {
  this.form.data.userId = id;
  this.form.visible = true;
  this.form.roleVisible = false;
}

function add() {
  this.form.data.userId = '';
  this.form.visible = true;
  this.form.roleVisible = false;
}

function del(id) {
  let that = this;
  this.$confirm({
      title: '是否删除这条数据?',
      content: '',
      okType: 'danger',
      async onOk() {
        const result = await delUser(id);
        if (result.code === 1200) {
          that.$message.success('删除成功')
          that.form.data = {};
          await that.getList();
        }
      },
      //   this.onCancel()
      onCancel() {
      },
      class:
        'test',
    }
  );
}

function addRole(id) {
  this.form.data.userId = id;
  this.form.visible = false;
  this.form.roleVisible = true;
}

function reset(id) {
  let that = this;
  this.$confirm({
      title: '是否重置密码?',
      content: '',
      async onOk() {
        const result = await resetPassword(id);
        if (result.code === 1200) {
          that.$confirm(
            { title: '重置后的密码为:' + result.data.password });
          that.form.data = {};
          await that.getList();
        }
      },
      //   this.onCancel()
      onCancel() {
      },
      class:
        'test',
    }
  );
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getList();
}

export default {
  components: {
    UserEdit,
    UserRole,
  },
  // watch: {
  //   table: {
  //     handler() {
  //
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    getList,
    onFormSave,
    onFormCancel,
    edit,
    add,
    del,
    addRole,
    reset,
    handleTableChange
  },
  created() {
    this.getList();
  },
  data() {
    return {
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
        sort: {
          prop: 'createAt',
          order: 'descend',
        },
      },
      form: {
        roleVisible: false,
        visible: false,
        data: {
          userId: '',
        },
      },
    };
  },
};
</script>

<style>

</style>
